/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChatRequest
 */
export interface ChatRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatRequest
     */
    input: string;
    /**
     * 
     * @type {Blob}
     * @memberof ChatRequest
     */
    image: Blob;
}

/**
 * Check if a given object implements the ChatRequest interface.
 */
export function instanceOfChatRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "input" in value;
    isInstance = isInstance && "image" in value;

    return isInstance;
}

export function ChatRequestFromJSON(json: any): ChatRequest {
    return ChatRequestFromJSONTyped(json, false);
}

export function ChatRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'input': json['input'],
        'image': json['image'],
    };
}

export function ChatRequestToJSON(value?: ChatRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'input': value.input,
        'image': value.image,
    };
}

